import { useEffect, useState } from "react";
import { needsYouApi } from "@/lib/api";
import { useInternalUi } from "@/hooks/useInternalUi";

export type AlertsAccess = "checking" | "enabled" | "disabled";

/**
 * Whether alerts are on for this person: internal staff only for now (useInternalUi), and only when the API
 * says so (it answers false to anyone else too). "checking" until the API has answered.
 */
export function useAlertsAccess(): AlertsAccess {
  const internal = useInternalUi();
  const [access, setAccess] = useState<AlertsAccess>("checking");
  useEffect(() => {
    if (!internal) return;
    let current = true;
    needsYouApi.list(1).then(
      (r) => current && setAccess(r.enabled ? "enabled" : "disabled"),
      () => current && setAccess("disabled"),
    );
    return () => {
      current = false;
    };
  }, [internal]);
  return internal ? access : "disabled";
}

/** False until known, so alert-only tabs stay hidden. */
export function useAlertsEnabled() {
  return useAlertsAccess() === "enabled";
}
